import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Page } from 'src/app/models/page.model';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController } from '@ionic/angular';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { Subscription, Subject } from 'rxjs';
import { SearchpopoverComponent } from 'src/app/shared/components/searchpopover/searchpopover.component';
import { SecondaryToolbarComponent } from 'src/app/shared/components/secondary-toolbar/secondary-toolbar.component';
import * as moment from 'moment';
@Component({
  selector: 'app-m-documentgenerator',
  templateUrl: './m-documentgenerator.page.html',
  styleUrls: ['./m-documentgenerator.page.scss'],
})
export class MDocumentgeneratorPage implements OnInit {
  @ViewChild('secondaryToolBar') secondary: SecondaryToolbarComponent;
  @ViewChild('table') table: DatatableComponent;
  page = new Page();
  rows = [];
  preventClick: boolean = true;

  itemsSelected: any = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;
  showPage: boolean = false;

  columnsWidth: any = [];


  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Name = (40 / 100) * tableWidth;
      this.columnsWidth.DocumentTemplateType = (25 / 100) * tableWidth;
      this.columnsWidth.VersionNumber = (15 / 100) * tableWidth;
      this.columnsWidth.DateCreated = (20 / 100) * tableWidth;
    }
    if (this.table && window.innerWidth < 800) {
      let tableWidth = this.table._innerWidth -30;
      this.columnsWidth.Name = (50 / 100) * tableWidth;
      this.columnsWidth.DocumentTemplateType = (30 / 100) * tableWidth;
      this.columnsWidth.VersionNumber = (20 / 100) * tableWidth;

    }
  }
  constructor(private router: Router, private route: ActivatedRoute, private _apiService: ApiService,private formBuilder: FormBuilder, public _commonService: CommonService, private popoverController: PopoverController, public ngxSmartModalService: NgxSmartModalService)
   {
    this.page.pageNumber = 0;
    this.page.size = 20;
    this.searchEvent = this._commonService.searchTextValue;
    //this.singleSelectCheck = this.singleSelectCheck.bind(this);
    }

  ngOnInit() {
  }
  public onLimitChange(limit: any): void {
    this.page.size = parseInt(limit, 10);
    if (this._commonService.searchText && this._commonService.searchText != ''){
      this.setPage({ offset: 0 }, this._commonService.searchText);
    }else{
      this.setPage({ offset: 0 }, '');
    }
  }

  ionViewDidLeave() {
    this.itemsSelected = [];
    this.table.selected = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if(this.toggleSubscription){
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewDidEnter() {
    this.itemsSelected = [];
    this.adjustColumnWidth();
    if (this.searchEvent) {
      this.searchSubscription = this.searchEvent.subscribe(event => {
        this.setPage({ offset: 0 }, event);
        this._commonService.searchText = event;
      });
    }
    this.setPage({ offset: this._commonService.currentPage ? this._commonService.currentPage : 0 }, this._commonService.searchText && this._commonService.searchText != '' ? this._commonService.searchText : '');
   this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
    setTimeout( () => {
      this.rows = [...this.rows];
      if (this.table) this.table.recalculate();
    },0)
  });
    this.resizeSubscription = this._commonService.onResize.subscribe(event => {
      this.adjustColumnWidth();
    });

  }
  /**
  * Populate the table with new data based on the page number
  * @param page The page to select
  */
 async setPage(pageInfo, searchText) {
  this._commonService.searchText = searchText;
  this._commonService.presentLoading();
  this._commonService.currentPage = pageInfo.offset;
  this.page.pageNumber = pageInfo.offset;
  this.table.offset = this.page.pageNumber;
  this._apiService.getDocumentTemplates(searchText ? searchText: "", this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size, 0, '').then(data => {
  this.page.totalElements = data.headers.get('X-Page-TotalCount');
    this.showPage = true;
    this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
    this.table.selected = [];
    if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
    this.rows = data.body.map(row => {
      row.DateCreated = moment(row.DateCreated).format('DD-MM-YYYY');
      return row; // Ensure to return the modified row
    });
    this._commonService.log(this.rows, this._commonService.LOG);
    this._commonService.dismiss();
  }).catch(err => {
    this._commonService.dismiss();
    this._commonService.log(err, this._commonService.ERROR);
  })
}

onActivate(event) {
  if (event.type == 'click' && event.cellIndex != 0) {
    if (this.preventClick) {
      sessionStorage.versionNumber=event.row.VersionNumber;
      this.router.navigate(['maintenance/documentgenerator/' + event.row.DocumentTemplateId]);
    }
  }
  if (event.type == 'checkbox') {
    this.preventClick = false;
    setTimeout(() => {
      this.preventClick = true
    }, 500)
  }
}

// singleSelectCheck(row: any) {
//   let selected = [];
//   let index = this.itemsSelected.indexOf(row.DocumentTemplateId) === -1;
//   if(index) {
//     selected.push(row.DocumentTemplateId);
//     this.itemsSelected = selected;
//   }else{
//     this.itemsSelected = selected;
//   }
//   return index;
// }

onSelect(event) {
  let selected = [];
  event.selected.forEach(element => {
    selected.push(element.DocumentTemplateId);
  });
  this.itemsSelected = selected;
}

add() {
  this.router.navigate(["maintenance/documentgenerator/0"]);
}

delete() {
  this._commonService.presentAlertConfirm()
    .then(async (res) => {
      try {
        this._commonService.presentLoading();
        await this._apiService.deleteDocumentTemplates(this.itemsSelected);
        this._commonService.dismiss();
        this._commonService.log(res, this._commonService.LOG);
        this.table.selected = [];
        this.itemsSelected = [];
        this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    })
    .catch((err) => {
      this._commonService.log(err, this._commonService.LOG);
    })
}


async presentSearchPopover(event: any) {
  const popover = await this.popoverController.create({
    component: SearchpopoverComponent,
    event: event,
    translucent: false,
    cssClass: 'searchPopOver'
  });
  return await popover.present();
}

goBack() {
  this.secondary.showSearchContainer = false;
  this._commonService.searchText = '';
  this._commonService.currentPage = 0;
  this._commonService.goBack('maintenance');
}

async onSort(event){
  const sort = event.sorts[0];
  this.page.orderBy = sort.prop.toLowerCase();
  this.page.orderDir = sort.dir;
  this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
}

onActionChange(obj) {

  switch (obj.Action) {
    case "add":
        this.add();
        break;
    case "delete":
        this.delete();
        break;
    case "search":
        this.itemsSelected=[];
        this.setPage({ offset: 0 }, obj.Event);
        break;
    case "close":
        this.itemsSelected=[];
        this.setPage({ offset: 0 }, "");
        break;
    case "backToMain":
        this.router.navigate(['maintenance'], { replaceUrl: true });
        break;
    case "back":
        this.goBack();
        break;
    }
}


}
